// extracted by mini-css-extract-plugin
module.exports = {"messageNotification":"_3SnzG","asRounded":"_14_yq","isExpanded":"_1yA98"};